import icon from '@/assets/brand/icon.png'
import logo from '@/assets/brand/logo.png'

/**
 * The product this build is. It ships in the bundle so the first paint is
 * already branded: waiting on an API call left the sign-in page and the shell
 * blank for a moment, and that read as broken. The originals live in the docs
 * repository (`brand/`).
 */
export const PRODUCT_BRAND = {
  name: 'MDM42',
  /** The full logo with its wordmark. */
  logoUrl: logo,
  /** The square mark alone. */
  iconUrl: icon,
} as const
